import store from '@/store';
import { creditScorCalculationDigitalRepository } from '@/forms/api/repository-factory';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import callApi from '@/lib/helpers/call-api';
import {
    SET_TRANSACTION_DECISION,
    SET_MAX_LOAN,
    SET_CREDIT_SCORE_CALCULATION_STATUS,
    SET_PRE_SCREENED_AMOUNT,
    SET_CREDIT_SCORE_CALCULATION_RES,
    SET_BUREAU_SCORE
} from '@/lib/constants/mutations';
const getPayload = () => {
    const { values } = store.state.formData;
    const { appId, cifnumber, productType } = store.state;

    const fixedIncome = getValueByFieldName(values, FIELD_NAMES.fixedIncome);
    const employmentType = getValueByFieldName(values, FIELD_NAMES.employmentType);
    const product = getValueByFieldName(values, FIELD_NAMES.product);
    var salesProduct;
    if (product === 'Top Up') {
        salesProduct = 'TOPUP'
    } else if (product === 'New Car' || product === 'Used Car') {
        salesProduct = 'Auto Loan'
    } else {

        salesProduct = product
    }
    const segment = function() {

        if (employmentType === 'Salaried') {
            if (fixedIncome < 7500) {
                return 'SMM'
            } else if (fixedIncome >= 7500) {
                return 'MAF';
            }
        } else if (employmentType === 'Self-employed') {
            return 'SEMM';
        }
    }
    if (product === 'Top Up' || product === 'New Car' || product === 'Used Car') {
        return {
            "app-id": appId,
            "cif-number": cifnumber,
            "segment": segment,
            "product": salesProduct,
            "declared-income": fixedIncome,
            "verified-income": 0,
            "negative-response": "false"
        };
    }
    return {
        "app-id": appId,
        "cif-number": cifnumber,
        "segment": segment,
        "product": productType, //"Personal Loan",
        "declared-income": fixedIncome,
        "verified-income": 0,
        "negative-response": "false"
    };

};

export default {
    creditScoreCalculation: async() => {
        // const { form } = currentStep;
        // var response = false;
        // response = await callApi({
        //     callbacks,
        //     form,
        //     formElement: currentStep,
        //     apiCall: creditScorCalculationeRepository.creditScoreCalculation,
        //     payload: getPayload(),
        // });
        const response = await creditScorCalculationDigitalRepository.creditScoreCalculation(getPayload());
        if (response) {
            // console.log(response.data['score-decision']);
            // console.log('inside response');
            // console.log(response['score-decision']);
            store.commit(SET_TRANSACTION_DECISION, {
                transactionStatus: response.data['score-decision'],
            });
            store.commit(SET_CREDIT_SCORE_CALCULATION_STATUS, {
                creditScoreCalculationSatus: response.data['score-decision'],
            });
            store.commit(SET_CREDIT_SCORE_CALCULATION_RES, {
                creditScoreCalculationRes: response.data,
            });

            if (response.data['score-decision'] === 'Approved' || response.data['score-decision'] === 'Conditionally Approved') {
                store.commit(SET_MAX_LOAN, { maxLoan: response.data['prescreened-amount'] });
                store.commit(SET_PRE_SCREENED_AMOUNT, { preScreendedAmount: response.data['prescreened-amount'] });
                store.commit(SET_BUREAU_SCORE, { bureauScore: response.data['bureau-score'] });

            }
        }
        //console.log(response['score-decision'].toUpperCase());

        return response.data['score-decision'].toUpperCase();
    }
};